export default __webpack_public_path__ + "static/media/753.e498f444.png";